import { render } from "./CancelSuscriptionForm.vue?vue&type=template&id=713fa53f"
import script from "./CancelSuscriptionForm.vue?vue&type=script&lang=js"
export * from "./CancelSuscriptionForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vhstrejo/Sites/todo-inclusion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__